import React, { useEffect, useRef, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { ModalRoutingContext } from 'bv-contexts';
import { useSelector, useStore } from 'react-redux';
import { routing as routingSelectors } from 'redux-selectors';
import { ModalRoutes, MainRoutes } from './components';
import { setProductIdCookie } from './helpers';
import { useIsFirstModal } from './hooks';

const { RouteService: { refresh, isModal } } = window;

const { getCurrentPath } = routingSelectors;

const ModalSwitch = () => {
  const location = useLocation();
  const lastMainLocation = useRef({ pathname: '/' });
  const currentPath = useSelector(getCurrentPath);
  const store = useStore();

  const locationIsModal = isModal(location.pathname);

  useEffect(() => {
    // Once all routing is in react, we do not need to store currentPath in redux
    // And the stuff done in RouteService can be done with a component using an effect
    // Like this one, executed when the pathname changes
    refresh();
    if (!locationIsModal) lastMainLocation.current = location;
  }, [location]);

  useEffect(() => {
    setProductIdCookie(store.getState());
  }, [currentPath, store]);

  const isFirstModal = useIsFirstModal(location, locationIsModal);
  const mainLocation = locationIsModal ? lastMainLocation.current : location;

  return (
    <>
      <MainRoutes location={mainLocation} />
      <ModalRoutingContext.Provider value={{ isFirstModal }}>
        <ModalRoutes />
      </ModalRoutingContext.Provider>
    </>
  );
};

export default memo(() => (
  <ModalSwitch />
));
